var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeviceCameraVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 5.25C24 4.9798 23.8547 4.73048 23.6195 4.59735C23.3844 4.46422 23.0958 4.46786 22.8641 4.60688L16.5 8.42536V6.25C16.5 5.2835 15.7165 4.5 14.75 4.5H1.75C0.783502 4.5 0 5.2835 0 6.25V17.25C0 18.2165 0.783502 19 1.75 19H14.75C15.7165 19 16.5 18.2165 16.5 17.25V15.0746L22.8641 18.8931C23.0958 19.0321 23.3844 19.0358 23.6195 18.9027C23.8547 18.7695 24 18.5202 24 18.25V5.25ZM16.5 13.3254L22.5 16.9254V6.57464L16.5 10.1746V13.3254ZM15 6.25C15 6.11193 14.8881 6 14.75 6H1.75C1.61193 6 1.5 6.11193 1.5 6.25V17.25C1.5 17.3881 1.61193 17.5 1.75 17.5H14.75C14.8881 17.5 15 17.3881 15 17.25V6.25Z",
    fill: "#111111"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceCameraVideo);
export default __webpack_public_path__ + "static/media/device-camera-video.9ff365bb.svg";
export { ForwardRef as ReactComponent };